module.exports = __webpack_public_path__ + "static/media/dark-submenu-dispositivo.61e64a28.svg";